export default __webpack_public_path__ + "static/media/no-events.d88a1ccc.svg";